var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_929_27)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.0229 2.65308H3.97714C1.78408 2.65308 0 4.44287 0 6.64246V13.3572C0 15.5572 1.78408 17.3465 3.97714 17.3465H16.0229C18.2159 17.3465 20 15.5567 20 13.3572V6.64246C20 4.44287 18.2159 2.65308 16.0229 2.65308ZM19.1837 13.3576C19.1837 15.1074 17.7657 16.5306 16.0229 16.5306H3.97714C2.23429 16.5306 0.816326 15.107 0.816326 13.3576V6.64246C0.816326 4.89308 2.23429 3.4694 3.97714 3.4694H16.0229C17.7657 3.4694 19.1837 4.89308 19.1837 6.64246V13.3576Z",
    fill: "#DA291C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.6163 9.85226L7.96121 6.54002C7.83549 6.46655 7.67917 6.46532 7.55223 6.53797C7.42529 6.61063 7.34692 6.74573 7.34692 6.89226V13.5163C7.34692 13.6625 7.42529 13.798 7.55182 13.8706C7.61468 13.9065 7.68488 13.9245 7.75509 13.9245C7.82652 13.9245 7.89754 13.9057 7.96121 13.8686L13.6163 10.5572C13.7412 10.4841 13.8184 10.3498 13.8184 10.2049C13.8184 10.06 13.7416 9.92532 13.6163 9.85226ZM8.16325 12.8041V7.6041L12.6024 10.2045L8.16325 12.8041Z",
    fill: "#DA291C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_929_27"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.1e82bb8e0511b7884c4f5941f4aee6f9.svg";
export { ForwardRef as ReactComponent };